var Enum = Enum || { MEEDY : {}};

Enum.MEEDY.VISIT_STATUS = {
    CLOSED: 'CLOSED',
    PLANNED: 'PLANNED',
    IN_PROGRESS: 'IN_PROGRESS',
    CANCELED_BY_PATIENT: 'CANCELED_BY_PATIENT',
    CANCELED_BY_DOCTOR: 'CANCELED_BY_DOCTOR',
    CANCELED_PATIENT_DID_NOT_SHOW_UP : 'CANCELED_PATIENT_DID_NOT_SHOW_UP',
    DID_NOT_TAKE_PLACE: 'DID_NOT_TAKE_PLACE',
    COMPLETED: 'COMPLETED'
};

Object.freeze(Enum.MEEDY.VISIT_STATUS);